/**
 * Custom sorting function that prioritizes strings containing specific keywords
 * in the order: 'enterprise', 'professional', 'starter', 'free', undefined from largest index to smallest
 *
 * @param apiName - First apiName to compare
 * @param apiNameB - Second apiName to compare
 * @returns A number indicating the sort order: negative if apiName should come before apiNameB,
 *          positive if apiName should come after apiNameB, or zero if they are equal
 * @example
 * ['starter', 'free', 'enterprise'].sort(sortByProductLevel) // => ['free', 'starter', 'enterprise']
 */
const PRODUCT_LEVEL_ORDER = ['free', 'starter', 'professional', 'enterprise'];
export function getProductLevelIndex(str) {
  const index = PRODUCT_LEVEL_ORDER.findIndex(keyword => str.toLowerCase().includes(keyword));
  return index === -1 ? PRODUCT_LEVEL_ORDER.length : index;
}
export function sortByProductLevel(apiName, apiNameB) {
  const priorityA = getProductLevelIndex(apiName);
  const priorityB = getProductLevelIndex(apiNameB);
  if (priorityA !== priorityB) {
    return priorityA - priorityB;
  }

  // If same priority, sort alphabetically
  return apiName.localeCompare(apiNameB);
}
const SEAT_BASED_SKU_CATEGORY_NAMES = ['COMMERCE_PRODUCTS', 'CRM_SUITE', 'SALES_PRODUCTS', 'SERVICE_HUB_PRODUCTS'];
export function isSeatBasedSkuCategoryName(skuCategoryName) {
  return SEAT_BASED_SKU_CATEGORY_NAMES.includes(skuCategoryName);
}